<template>
  <modal-padrao
    ref="modal"
    max-width="900px"
    :titulo="'Importar dados'"
    :titulo-ok="$t('geral.botoes.salvar')"
    :titulo-cancelar="'Fechar'"
    :mostra-botao-salvar="!isLoadingEnsaio"
    @ok="salvar"
  >
    <div class="row">
      <div class="pt-0 mt-8 col-12">
        <a
          icon
          target="_self"
          :href="downloadLink"
          download="arquivo.xlsx"
        >
          <v-icon left>
            pi pi-download
          </v-icon>
          Arquivo de exemplo
        </a>
        <div
          v-if="isLoadingEnsaio"
          class="overlay"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
          <span>Processando arquivo...</span>
        </div>
      </div>
    </div>
    <div class="row">
      <input-file-drag-n-drop
        v-model="form.arquivo"
        class="pt-0 col-12"
        accept=".xls, .xlsx"
      />
    </div>
  </modal-padrao>
</template>
  
<script>
import CalibracaoService from '@/common/services/cadastros/CalibracaoService';
import _ from 'lodash';
import { mapActions, mapGetters, mapMutations } from 'vuex';
  
export default {
    props: {
        calibracaoId: { type: String, default: '' },
    },
    data() {
      return {
        form: {
          calibracaoId: '',
          arquivo: [],
        },
        downloadLink: 'https://docs.google.com/spreadsheets/d/1ZKtctA1v2aaRD-AmtQQwEERps5AiEPNusUQj7cJc9RY/export?format=xlsx'
      };
    },
    computed: {
      ...mapGetters('Calibracao', ['isLoadingEnsaio']),
    },
    methods: {
      ...mapActions('Calibracao', ['processarArquivoEnsaio']),
      ...mapMutations('Calibracao', ['SET_LOADING_ENSAIO', 'SET_RECARREGA_VALORES']),

        abrirModal() {
            this.$refs.modal.abrirModal();
        },
        decodeBase64(base64String) {
            const cleanedBase64String = this.cleanBase64String(base64String);

            try {
                const decodedData = atob(cleanedBase64String);
                return decodedData;
            } catch (error) {
                console.error("Erro ao decodificar a string Base64:", error);
                return null;
            }
        },
        cleanBase64String(base64String) {
            base64String = base64String.replace(/\s/g, '');

            const missingPadding = base64String.length % 4;
            if (missingPadding) {
                base64String += '='.repeat(4 - missingPadding);
            }

            return base64String;
        },
        salvar() {
          this.SET_LOADING_ENSAIO(true);

          let form = _.cloneDeep(this.form);
          if (form.arquivo.length === 0) return;

          form.nomeArquivo = form.arquivo[0].nome;
          form.descricao = form.arquivo[0].nome;
          form.extensaoArquivo = form.arquivo[0].extensao;
          let arquivoBase64 = form.arquivo[0].base64.split(',')[1];

          form.arquivo = arquivoBase64;
          form.calibracaoId = this.calibracaoId;

          new Promise((resolve) => {
            setTimeout(() => {
              resolve(CalibracaoService.ensaio(this.calibracaoId, form));
            }, 100);
          })
          .then(() => {
            this.$refs.modal.fecharModal();
            this.$emit('listar');
          })
          .finally(() => {
            this.SET_LOADING_ENSAIO(false);
            this.SET_RECARREGA_VALORES(true)

          });
        }},
};
</script>
<style scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: not-allowed;
}
</style>